"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _7DAL4U2Wcjs = require('./7DAL4U2W.cjs');


var _QWIBF3KBcjs = require('./QWIBF3KB.cjs');





var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/toolbar/toolbar-item.tsx
var TagName = "button";
var useToolbarItem = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useToolbarItem2({ store, ...props }) {
    const context = _7DAL4U2Wcjs.useToolbarContext.call(void 0, );
    store = store || context;
    props = _QWIBF3KBcjs.useCompositeItem.call(void 0, { store, ...props });
    return props;
  }
);
var ToolbarItem = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function ToolbarItem2(props) {
    const htmlProps = useToolbarItem(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);




exports.useToolbarItem = useToolbarItem; exports.ToolbarItem = ToolbarItem;
